import { useFormik } from "formik";
import CustomButton from "../../../Components/Atoms/CustomButton";
import * as Yup from "yup";
import { useEffect, useState } from "react";
import OTPInput from "../../../Components/Molecules/OTPInput/Index";
import { differenceInSeconds } from "date-fns";
import { useDispatch } from "react-redux";
import { OTP_ACTION } from "../../../Constant";
import { postOTPActionRequest } from "../../../Redux/VisitorLogs/VisitorLogsActions";

let id;

const VisitorOtpVerification = ({
  handleClose,
  updateInterval,
  otp_formik,
}) => {
  const { expires_on, created_at } = updateInterval;

  const time_interval = differenceInSeconds(expires_on, created_at);

  const [secondsRemaining, setSecondsRemaining] = useState(time_interval);

  const dispatch = useDispatch();

  const { type, email_value, number_value } = otp_formik.values;

  const formik = useFormik({
    initialValues: {
      otp: new Array(6).fill(""),
    },
    onSubmit: (values) => {
      dispatch(
        postOTPActionRequest({
          otp: Number(values.otp.join("")),
          action: OTP_ACTION.VERIFY,
          type,
          email_value,
          number_value,
        })
      );
    },
    validationSchema: Yup.object().shape({
      otp: Yup.array().of(
        Yup.string()
          .matches(/^\d{1}$/, "Must be exactly 6 digits")
          .required("Required")
      ),
    }),
  });

  useEffect(() => {
    id = setInterval(() => {
      fn();
    }, 1000);
  }, []);

  const fn = () => {
    setSecondsRemaining((prev) => {
      if (prev === 0) {
        clearInterval(id);
        return prev;
      }
      return prev - 1;
    });
  };

  return (
    <>
      <div>
        <OTPInput
          size={6}
          secondsRemaining={secondsRemaining}
          formik={formik}
        />
      </div>
      <div className="btnActnBar">
        {secondsRemaining > 0 ? (
          <CustomButton
            label={"Verify OTP"}
            disabled={Object.keys(formik.errors).length > 0}
            onClick={formik.handleSubmit}
            action={"VERIFY"}
          />
        ) : (
          <CustomButton
            btnType={"secondary"}
            label={"Close"}
            onClick={handleClose}
            action={"CANCEL"}
          />
        )}
      </div>
    </>
  );
};
export default VisitorOtpVerification;
